import type { CSSObject } from '@emotion/react';
import { Theme } from '@mui/material';

export const getOrderSummaryActionButtonStyles = (theme: Theme): CSSObject => ({
  width: 'fit-content',
  height: 24,
  paddingTop: theme.spacing(0.75),
  paddingLeft: theme.spacing(1.5),
  paddingRight: theme.spacing(1.5),
  paddingBottom: theme.spacing(0.75),
  '& .MuiButton-startIcon': {
    marginRight: theme.spacing(0.75),
  },
});
